<template>
    <div>
        <div class="mr-2" id="search-box">
            <fa icon="times" @click="keyword = ''" v-if="keyword !== ''"></fa>
            <b-form-input v-model="searchKeyword" :placeholder="$t('core.search')"></b-form-input>
        </div>

        <div v-if="keyword !== ''" id="search-result">
            <template v-if="searching">
                Searching...
            </template>
            <template v-else>
                <template v-if="result.contracts.length === 0">
                    No results
                </template>
                <template v-else>
                    <div v-for="contract in result.contracts" :key="contract.id">
                        <div class="d-flex">
                            <span class="pr-2">
                                {{contract.contract_no}}
                                {{contract.master_address.length >= 1 ? '- ' + contract.master_address[0].company_name : ''}}
                            </span>

                            <router-link :to="{ path: '/sandoz/contracts/' + contract.id }"
                                         class="ml-auto">
                                <fa icon="arrow-right"/>
                            </router-link>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </div>

</template>

<style scoped lang="scss">
#search-box {
    position: relative;

    svg {
        position: absolute;
        right: 5px;
        top: 10px;
    }
}
#search-result {
    position: absolute;
    right: 0px;
    min-width: 450px;
    background: white;
    padding: 1rem;
    border: 1px solid silver;
    max-height: calc(100vh - 100px);
    overflow: auto;
}
</style>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            show: true,
            keyword: '',
            timeout: false,
            searching: false,
            result: {
                contracts: []
            }
        }
    },
    methods: {
        onShown() {
            this.$set(this.result, 'contracts', this.result.contracts)
        }
    },
    watch: {
        keyword() {
            var self = this
            var params = {
                q: this.keyword
            }
            this.searching = true
            axios.post('/api/sandoz/search', params).then((response) => {
                self.$set(self.result, 'contracts', response.data.contracts)
                self.searching = false
            }).catch((error) => {
                self.searching = false
                console.log(error)
            })
        }
    },
    computed: {
        searchKeyword: {
            get() {
                return this.keyword
            },
            set(val) {
                if (this.timeout) {
                    clearTimeout(this.timeout)
                }
                this.timeout = setTimeout(() => {
                    this.keyword = val
                }, 300)
            }
        },
        showResult() {
            return this.keyword !== ''
        }
    }
}
</script>
